import KindergartenConfig from '../../dto/federation/KindergartenConfig';
import axios from 'axios';

export default class KindergartenConfigRepository {
    static find(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/kindergarten-configs`)
                .then((response) => resolve(response.data.data.map((data) => KindergartenConfig.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(federationId, kindergartenConfigs) {
        const data = { kindergartenConfigs: kindergartenConfigs.map((kindergartenConfig) => kindergartenConfig.serialize()) };
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/kindergarten-configs`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
